import store from '../store';
import api from '../api';

const sm2 = require('sm-crypto').sm2;

/**
 * 将JSON数据格式化展示
 * @param {Object} obj 数据对象
 */
const writeHtml = (obj) => {
  if (obj) {
    let res = JSON.stringify(obj, null, 4); // 缩进4个空格
    return res;
  } else {
    return '';
  }
};

/**
 * 根据id判断是否拥有此模块功能
 * @param {Number} id 模块权限id
 */
const hasModule = (id) => {
  let moduleAuth = store.state.login.moduleAuth;
  let flag = false;
  for (let i = 0; i < moduleAuth.length; i++) {
    let item = moduleAuth[i];
    if (item && item.auth_id === id) {
      flag = true;
    }
  }
  return flag;
};

/**
 * 过去日期时间数组
 * @param {Number} number 获取几天(正数为获取未来时间,负数为之前时间)
 * @param {Boolean} noToday 是否不包含今天开始计算, 默认false 包含
 * @param {String} type 返回的年月日格式(默认YYYY-MM-DD,可选返回MM-DD)
 */
const getDayList = (number, noToday, type) => {
  function doHandleMonth(month) {
    let m = month;
    if (month.toString().length == 1) {
      m = '0' + month;
    }
    return m;
  }
  function timeString(val) {
    let day = val || 0;
    let today = noToday ? new Date(new Date().getTime() - 1000 * 60 * 60 * 24) : new Date();
    let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
    today.setTime(targetday_milliseconds); /* 注意，这行是关键代码 */
    let tYear = today.getFullYear();
    let tMonth = today.getMonth();
    let tDate = today.getDate();
    tMonth = doHandleMonth(tMonth + 1);
    tDate = doHandleMonth(tDate);
    return type == 'MM-DD' ? tMonth + '-' + tDate : tYear + '-' + tMonth + '-' + tDate;
  }
  let result = [];
  if (number >= 0) {
    for (let index = 0; index < number; index++) {
      result.push(timeString(index));
    }
  } else {
    for (let index = number + 1; index < 1; index++) {
      result.push(timeString(index));
    }
  }
  return result;
};

/**
 * 过去月份时间数组
 * @param {Number} number 获取几个月(正数为获取未来时间,负数为之前时间)
 * @param {String} start 开始月份时间(默认为当前月)
 */
const getMonthList = (number, start) => {
  let result = [];
  let date = start ? new Date(start) : new Date();
  date.setDate('1');
  function addMonth(index) {
    let a = index > -1 ? 1 : -1;
    let m = date.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    let res = date.getFullYear() + '-' + m;
    date.setMonth(date.getMonth() + a); //每次循环一次 月份值减1
    return res;
  }

  if (number >= 0) {
    for (let index = 0; index < number; index++) {
      result.push(addMonth(index));
    }
  } else {
    for (let index = number; index < 0; index++) {
      result.unshift(addMonth(index));
    }
  }
  return result;

  // let result = [];
  // let startDay = start.split('-');
  // let diffDay = new Date();
  // let dateList = new Array;
  // diffDay.setDate('1');
  // diffDay.setMonth(startDay[1] - 1);
  // diffDay.setFullYear(startDay[0]);
  // result.push(start);

  // function addMonth(val) {
  //     let countDay = val > -1 ? diffDay.getTime()+24 * 60 * 60 * 1000 * 31 : diffDay.getTime()-24 * 60 * 60 * 1000 * 31;
  //     diffDay.setTime(countDay);
  //     diffDay.setDate(val > -1 ? '1' : '28');
  //     dateList[2] = diffDay.getDate();
  //     dateList[1] = val > -1 ? diffDay.getMonth() + 1 : diffDay.getMonth() - 1;
  //     dateList[0] = diffDay.getFullYear();
  //     if (String(dateList[1]).length == 1) { dateList[1] = '0' + dateList[1]; }
  //     if (String(dateList[2]).length == 1) { dateList[2] = '0' + dateList[2]; }
  //     return dateList[0] + '-' + dateList[1];
  // }

  // if (number >= 0) {
  //     for (let index = 0; index < number; index++) {
  //         result.push(addMonth(index));
  //     }
  // } else {
  //     for (let index = number + 1; index < 1; index++) {
  //         result.push(addMonth(index));
  //     }
  // }

  // return result;
};

/**
 * 获取两个值之间的随机整数值, 可定义返回数组
 * @param {Number} min 最小值
 * @param {Number} max 最大值
 * @param {Number} val 获取多个, 默认返回一个, 多个返回数组
 */
const getRandom = (min, max, val) => {
  if (val) {
    let list = [];
    for (let index = 0; index < val; index++) {
      list.push(Math.floor(Math.random() * (max - min)) + min);
    }
    return list;
  } else {
    return Math.floor(Math.random() * (max - min)) + min;
  }
};

/**
 * 获取两个日期之间的日期数组, 格式: YYYY-MM-DD
 * @param {String} start 时间字符串 格式: YYYY-MM-DD
 * @param {String} end 时间字符串 格式: YYYY-MM-DD
 */
const getStartEndDaysList = (start, end) => {
  if (start && end) {
    let result = [];
    let startDay = start.split('-');
    let ymdType = startDay[2] ? 'YYYY-MM-DD' : 'YYYY-MM';
    let endDay = end.split('-');
    let diffDay = new Date();
    let dateList = new Array();
    let i = 0;
    diffDay.setDate(ymdType === 'YYYY-MM' ? '1' : startDay[2]);
    diffDay.setMonth(startDay[1] - 1);
    diffDay.setFullYear(startDay[0]);
    result.push(start);
    if (start === end) {
      return result;
    } else {
      while (i == 0) {
        let countDay =
                    ymdType === 'YYYY-MM'
                      ? diffDay.getTime() + 24 * 60 * 60 * 1000 * 31
                      : diffDay.getTime() + 24 * 60 * 60 * 1000;
        diffDay.setTime(countDay);
        if (ymdType === 'YYYY-MM') {
          diffDay.setDate('1');
        }
        dateList[2] = diffDay.getDate();
        dateList[1] = diffDay.getMonth() + 1;
        dateList[0] = diffDay.getFullYear();
        if (String(dateList[1]).length == 1) {
          dateList[1] = '0' + dateList[1];
        }
        if (String(dateList[2]).length == 1) {
          dateList[2] = '0' + dateList[2];
        }
        result.push(
          ymdType === 'YYYY-MM'
            ? dateList[0] + '-' + dateList[1]
            : dateList[0] + '-' + dateList[1] + '-' + dateList[2]
        );
        if (ymdType === 'YYYY-MM' && dateList[0] == endDay[0] && dateList[1] == endDay[1]) {
          i = 1;
        }
        if (
          dateList[0] == endDay[0] &&
                    dateList[1] == endDay[1] &&
                    dateList[2] == endDay[2]
        ) {
          i = 1;
        }
      }
    }
    return result;
  } else {
    return [];
  }
};

/**
 * 每三位数加逗号
 */
const formatNumber = (num) => {
  return num.toString().replace(/\d+/, function (n) {
    return n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  });
};

/**
 * 获取用户菜单权限
 */
const getMenu = () => {
  return api.user.getMenu().then((res) => {
    if (res.code == 10000) {
      const menuData = (res.data || []).map((menuDataItem) => {
        return {
          ...menuDataItem,
          // 处理iotfont覆盖el-icon样式
          icon: menuDataItem.icon&&menuDataItem.icon.indexOf('el-icon-')>-1?`eliconfont ${menuDataItem.icon}`:`iotfont ${menuDataItem.icon}`
        };
      });
      let menus = []; // 菜单权限
      let moduleAuth = []; // 操作权限
      for (let i = 0; i < menuData.length; i++) {
        let item = menuData[i];
        const childrenName = 'child_menu';
        if (item[childrenName] && item[childrenName].length) {
          for (let j = 0; j < item[childrenName].length; j++) {
            let children = item[childrenName][j];
            menus.push(children.url);
            moduleAuth = moduleAuth.concat(children.auth_list);
          }
        } else {
          menus.push(item.url);
          moduleAuth = moduleAuth.concat(item.auth_list);
        }
      }
      store.commit('saveUserMenu', menus); // 保存操作权限数组表
      store.commit('saveMenuData', menuData); // 保存操作权限数组表
      store.commit('saveModuleAuth', moduleAuth); // 保存操作权限数组表
      console.log(menus);
      console.log(moduleAuth);
    }
  });
};

// 生成加密公钥/私钥
const geEncryption = () => {
  let keypair = sm2.generateKeyPairHex();
  return {
    publicKey: keypair.publicKey.toUpperCase(),
    privateKey: keypair.privateKey.toUpperCase()
  };
};

// 公钥加密
const encryptDecs = (data) => {
  const publicKey = '04C434734EAD9E5B0139D5DDD6EB17F0AAC5487763724FA932DE9A54EA27E2B2A8A6F7C219D26BF0FAF979DF93638618AE63B7E91905FF2C68C70AEF272EE3663C';
  return sm2.doEncrypt(data, publicKey);
};

export default {
  writeHtml,
  hasModule,
  getDayList,
  getMonthList,
  getRandom,
  getStartEndDaysList,
  formatNumber,
  getMenu,
  geEncryption,
  encryptDecs
};
